module.exports = __webpack_public_path__ + "static/ratm-poster-836ae883da39da2e69108142e5c141a1.jpg";